import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Award, Book, Heart } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-emerald-600 mb-4">ئۇيغۇرچە سۆز زەنجىرى</h1>
          <p className="text-xl text-gray-600 mb-6 uyghur-text">
            سۆزلەرنى ئۆگىنىش ۋە سۆز بايلىقىڭىزنى ئاشۇرۇش ئۈچۈن ئەڭ كۆڭۈللۈك ئويۇن!
          </p>
          <Link 
            to="/game" 
            className="btn btn-primary btn-lg inline-flex items-center"
          >
            <Play size={20} className="mr-2" />
            <span>ھازىر ئويناش</span>
          </Link>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="game-card text-center">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Play size={32} className="text-emerald-600" />
            </div>
            <h3 className="text-xl font-semibold text-emerald-600 mb-2">قىزىقارلىق ئويۇن</h3>
            <p className="text-gray-600 uyghur-text">
              سۆزنىڭ ئاخىرقى ھەرپى بىلەن باشلانغان يېڭى سۆزنى كىرگۈزۈڭ. قانچە كۆپ سۆزنى زەنجىردەك باغلىسىڭىز، شۇنچە كۆپ نومۇر توپلايسىز!
            </p>
          </div>
          
          <div className="game-card text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Book size={32} className="text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-blue-600 mb-2">تىل ئۆگىنىش</h3>
            <p className="text-gray-600 uyghur-text">
              ئويۇن جەريانىدا يېڭى سۆزلەرنى ئۆگىنىڭ، سۆز بايلىقىڭىزنى ئاشۇرۇڭ ۋە تىل ماھارىتىڭىزنى يۇقىرى كۆتۈرۈڭ. بۇ ئويۇندا 35,000 دىن ئارتۇق ئۇيغۇرچە سۆز بار!
            </p>
          </div>
          
          <div className="game-card text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Award size={32} className="text-purple-600" />
            </div>
            <h3 className="text-xl font-semibold text-purple-600 mb-2">مۇسابىقە</h3>
            <p className="text-gray-600 uyghur-text">
              ئەڭ يۇقىرى نومۇرنى توپلاپ، رېكورتلار تاختىسىغا كىرىڭ. دوستلىرىڭىز بىلەن بەسلىشىپ، كىم ئەڭ كۆپ نومۇر توپلايدىغانلىقىنى كۆرۈڭ!
            </p>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4 text-center">ئويۇن قائىدىلىرى</h2>
          <ul className="space-y-2 text-gray-700 uyghur-text">
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">1</div>
              <span>ھەر بىر سۆز ئالدىنقى سۆزنىڭ ئاخىرقى ھەرپى بىلەن باشلىنىشى كېرەك.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">2</div>
              <span>ئەگەر سۆز "ڭ" بىلەن ئاخىرلاشسا، كېيىنكى سۆز خالىغان ھەرپ بىلەن باشلانسا بولىدۇ.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">3</div>
              <span>بىر سۆزنى قايتا ئىشلەتسىڭىز بولمايدۇ.</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="bg-emerald-100 text-emerald-800 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">4</div>
              <span>تەڭشەكلەردە قىيىنلىق دەرىجىسىنى، ۋاقىت چەكلىمىسىنى ۋە باشقا تەڭشەكلەرنى تاللىيالايسىز.</span>
            </li>
          </ul>
        </div>
        
        <div className="text-center">
          <Link to="/game" className="btn btn-primary inline-flex items-center">
            <Play size={20} className="mr-2" />
            <span>ھازىر ئويناش</span>
          </Link>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default HomePage;